/**
 * Снимок к сообщению поддержки — общий для приложения и админки: админка не
 * тянет за ним синхронизацию и хранилище приложения.
 */

/**
 * Снимок экрана — сжатым JPEG до 1600 точек по длинной стороне: снимок
 * iPhone весит несколько мегабайт, а разглядеть экран хватает и этого.
 */
export async function shrinkImage(file: File, side = 1600): Promise<string> {
  const url = URL.createObjectURL(file);
  try {
    const img = await new Promise<HTMLImageElement>((ok, fail) => {
      const i = new Image();
      i.onload = () => ok(i);
      i.onerror = () => fail(new Error('Не получилось открыть картинку'));
      i.src = url;
    });
    const k = Math.min(1, side / Math.max(img.naturalWidth, img.naturalHeight));
    const canvas = document.createElement('canvas');
    canvas.width = Math.round(img.naturalWidth * k);
    canvas.height = Math.round(img.naturalHeight * k);
    canvas.getContext('2d')?.drawImage(img, 0, 0, canvas.width, canvas.height);
    return canvas.toDataURL('image/jpeg', 0.82);
  } finally {
    URL.revokeObjectURL(url);
  }
}
